export const DEFAULT_SONG_ID = "shutter-chance";

// Magical Mirai 2026 designated songs with revision IDs pinned from
// https://developer.textalive.jp/events/magicalmirai2026/
export const SONGS = [
  {
    id: "answer-me",
    title: "Answer Me",
    originalTitle: "こたえて",
    artist: "imie",
    role: "Grand Prize",
    songUrl: "https://piapro.jp/t/6W2N/20251215164617",
    lyricUrl: "https://piapro.jp/t/9o24",
    video: {
      beatId: 4827293,
      chordId: 2963754,
      repetitiveSegmentId: 3086261,
      lyricId: 126519,
      lyricDiffId: 28645,
    },
  },
  {
    id: "after-the-curtain",
    title: "After The Curtain",
    artist: "Rulmry",
    role: "Runner-Up",
    songUrl: "https://piapro.jp/t/zoqO/20251214200738",
    lyricUrl: "https://piapro.jp/t/EVO2",
    video: {
      beatId: 4827294,
      chordId: 2963755,
      repetitiveSegmentId: 3086262,
      lyricId: 126591,
      lyricDiffId: 28627,
    },
  },
  {
    id: "shutter-chance",
    title: "Shutter Chance",
    artist: "Yamiagari",
    role: "Runner-Up",
    songUrl: "https://piapro.jp/t/PNpQ/20251209170719",
    lyricUrl: "https://piapro.jp/t/wyWv",
    video: {
      beatId: 4827295,
      chordId: 2963756,
      repetitiveSegmentId: 3086263,
      lyricId: 126542,
      lyricDiffId: 28628,
    },
  },
  {
    id: "last-march",
    title: "The Last March on Earth",
    originalTitle: "世界最後の音楽隊",
    artist: "Natsuyama Yotsugi x Dopam!ne",
    role: "Runner-Up",
    songUrl: "https://piapro.jp/t/B3yJ/20251215061727",
    lyricUrl: "https://piapro.jp/t/9U-6",
    video: {
      beatId: 4827296,
      chordId: 2963757,
      repetitiveSegmentId: 3086264,
      lyricId: 126594,
      lyricDiffId: 28629,
    },
  },
  {
    id: "toritsukulogy",
    title: "Toritsukulogy",
    originalTitle: "トリツクロジー",
    artist: "Tsuruzou",
    role: "Runner-Up",
    songUrl: "https://piapro.jp/t/QBdL/20251215094303",
    lyricUrl: "https://piapro.jp/t/Nixq",
    video: {
      beatId: 4827297,
      chordId: 2963758,
      repetitiveSegmentId: 3086265,
      lyricId: 126593,
      lyricDiffId: 28630,
    },
  },
  {
    id: "takeover",
    title: "TAKEOVER",
    artist: "Twinfield",
    role: "Runner-Up",
    songUrl: "https://piapro.jp/t/E2i3/20251215092113",
    lyricUrl: "https://piapro.jp/t/zxWP",
    video: {
      beatId: 4827298,
      chordId: 2963759,
      repetitiveSegmentId: 3086266,
      lyricId: 126533,
      lyricDiffId: 28631,
    },
  },
];

export const SONG_BY_ID = Object.fromEntries(SONGS.map((song) => [song.id, song]));

export function findSongByUrl(url) {
  if (!url) return null;
  return SONGS.find((song) => url.startsWith(song.songUrl) || song.songUrl.startsWith(url));
}
